import { FetchControl, WalletTabType, WalletTransactionSourceType, WalletTransactionStatus } from '@/src/types/wallet'

export const WALLET_TABS: WalletTabType[] = ['EARNED', 'USED', 'REFUND']

export interface WalletBrandFilterOption {
    label: string
    value: FetchControl
    translationKey: string
}

export const WALLET_BRAND_FILTERS: WalletBrandFilterOption[] = [
    { label: 'All', value: 'ALL', translationKey: 'brandFilters.all' },
    { label: 'Flyin Wallet', value: 'MAIN', translationKey: 'brandFilters.flyinWallet' },
    { label: 'Cleartrip Wallet', value: 'LINKED', translationKey: 'brandFilters.cleartripWallet' }
]

export const SOURCE_TYPE_LABELS: Record<WalletTransactionSourceType | string, string> = {
    F: 'Flight',
    H: 'Hotel',
    FPH: 'Flights and Hotel',
    FC: 'Flyin Cash',
    Qitaf: 'Qitaf',
    WCB: 'Cashback',
    BOOKING: 'Booking',
    REDEEM: 'Redeem',
    REFERRAL_BONUS: 'Referral bonus'
}

export type TransactionIconType = 'refresh' | 'gift' | 'card'

export const SOURCE_TYPE_ICON_TYPES: Record<WalletTransactionSourceType | string, TransactionIconType> = {
    F: 'card',
    H: 'card',
    FPH: 'card',
    FC: 'gift',
    Qitaf: 'gift',
    WCB: 'gift',
    BOOKING: 'card',
    REDEEM: 'card',
    REFERRAL_BONUS: 'gift'
}

export const TRANSACTION_STATUS_LABELS: Record<WalletTransactionStatus, string> = {
    active: 'Active',
    inactive: 'Inactive',
    'in active': 'Inactive'
}

export const SOURCES_WITH_REFERENCE: WalletTransactionSourceType[] = ['F', 'H', 'WCB', 'BOOKING', 'REDEEM']
